import { Dumbbell } from "lucide-react";

export const CompletionMessage = () => {
  return (
    <div className="space-y-3 sm:space-y-4">
      <h1 className="text-2xl sm:text-4xl font-bold bg-gradient-to-r from-primary via-white to-primary bg-clip-text text-transparent animate-[pulse_3s_ease-in-out_infinite]">
        ¡Entrenamiento Completado!
      </h1>
      <p className="text-white/80 text-sm sm:text-lg">
        Has completado todos los ejercicios. ¡Excelente trabajo! 💪
      </p>
      <div className="mt-2 sm:mt-4 p-3 sm:p-4 bg-white/10 backdrop-blur-lg rounded-xl text-left">
        <div className="flex items-center gap-2 text-primary">
          <Dumbbell className="h-4 w-4 sm:h-5 sm:w-5" />
          <span className="font-medium text-sm sm:text-base">Recordatorio:</span>
        </div>
        <p className="text-white/80 mt-2 text-xs sm:text-base">
          No olvides realizar los ejercicios de elongación para una mejor recuperación.
        </p>
      </div>
    </div>
  );
};